import { fromJS, Map } from 'immutable';

export function request(state, action) {
    let collections = state.get('collections');

    collections = collections.setIn(['email', action.documentId], fromJS({
        state: 'IN_PROGRESS',
    }));

    return state.set('collections', collections);
}

export function error(state, action) {
    let collections = state.get('collections');

    collections = collections.setIn(['email', action.documentId], fromJS({
        state: 'ERROR',
        errors: action.errors
    }));

    return state.set('collections', collections);
}

export function finish(state, { documentId, data }) {
    let collections = state.get('collections');

    collections = collections.setIn(['email', documentId], fromJS({
         state: 'FINISHED'
    }));

    let items = state.get('items');

    return state
        .set('items', items)
        .set('collections', collections);
}

export function clear(state, { documentId }) {
    return state.setIn(['collections', 'email'], state.getIn(['collections', 'email']).remove(documentId));
}

